import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Settings } from '../../core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DefaultColumnModel, ViewColumnInfo } from './admin-edit-column-info';

@Injectable()
export class AdminEditColumnStorage {
    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) { }

    public getCustomViewList(): Observable<any> {
        return this.http.get(`${this.settings.apiUrl}/admin/sampletracker/viewsreportslist`)
            .pipe(map(((result: any) => {
                return result.viewReportListData;
        })));
    }

    public getViewColumnDetailsById(viewName: any): Observable<any> {
        return this.http.get(`${this.settings.apiUrl}/admin/sampletracker/dynamiccolumndetails/${viewName}`)
            .pipe(map(((result: any) => {
                return result.dynamicColumnDetailsData;
        })));
    }

    public saveDefaultColumns(requestInfo: any) {
        return this.http.put(`${this.settings.apiUrl}/admin/sampletracker/updatedefaultcolumnsandsequence`, requestInfo);
    }

    public saveUpdatedColumnInfo(requestInfo: any) {
        let requestData = {
            columnDetails: requestInfo
        };
        return this.http.put(`${this.settings.apiUrl}/admin/sampletracker/updatecolumndetails`, requestData);
    }

    public addNewColumn(requestInfo: any) {
        let requestData = {
            columnDetails: requestInfo
        };
        return this.http.post(`${this.settings.apiUrl}/admin/sampletracker/insertcolumndetails`, requestData);
    }

    public deleteColumn(appDataColumnDefinitionId: any) {
        return this.http.delete(`${this.settings.apiUrl}/admin/sampletracker/deletecolumndetails/${appDataColumnDefinitionId}`);
    }
}
